import ActionTypes from 'constants/ActionTypes';

export const gtmTrack = payload => ({
    type: ActionTypes.ANALYTICS_TRACK,
    payload,
});
